import React, { ReactHTMLElement, ReactNode } from 'react';

// eslint-disable-next-line @typescript-eslint/ban-types
export function isValidHtmlElement<E extends HTMLElement = HTMLElement>(obj: {} | null | undefined, type: keyof JSX.IntrinsicElements): obj is ReactHTMLElement<E> {
  return React.isValidElement(obj) && obj.type === type;
}

export function getLastFooterElement(children: Exclude<ReactNode, boolean | null | undefined>[]) {
  if (children.length < 1) return null;

  const last = children[children.length-1];

  return isValidHtmlElement(last, 'footer') ? last : null;
}
